import React from "react";
import { connect } from "react-redux";
import compose from "recompose/compose";
import UserIcon from "material-ui/svg-icons/social/group";
import { translate, MenuItemLink, WithPermission } from "admin-on-rest";
import { List, ListItem } from 'material-ui/List';
import menuStyle from "./style";
import SpeltipsIcon from "./MenuIcons/SpeltipsIcon.js";
import PromotionsIcon from "./MenuIcons/PromotionsIcon.js";
import MarketingPartnersIcon from "./MenuIcons/MarketingPartnersIcon.js";
import WelcomeMessageIcon from "./MenuIcons/WelcomeMessageIcon.js";
import DevicesIcon from "./MenuIcons/DevicesIcon.js";
import RegionsIcon from "./MenuIcons/RegionsIcon.js";
import VirtualslipsIcon from "./MenuIcons/VirtualslipsIcon.js";
import StoresIcon from "./MenuIcons/StoresIcon.js";
import CustomersIcon from "./MenuIcons/CustomersIcon.js";
import ReportsIcon from "./MenuIcons/ReportsIcon.js";
import GiftCardIcon from "./MenuIcons/GiftCardIcon.js";
import { BMTheme } from "../../BMTheme";
import RightArrowIcon from "./MenuIcons/RightArrowIcon";

const adminItems = [
  {
    primaryText: "resources.storeOwners.name",
    name: "partners",
    icon: <UserIcon color={BMTheme.icons.color} />
  },
  {
    primaryText: "resources.stores.name",
    name: "kiosks",
    icon: <StoresIcon color={BMTheme.icons.color} />
  },
  {
    primaryText: "resources.marketingPartners.name",
    name: "marketing_partners",
    icon: <MarketingPartnersIcon color={BMTheme.icons.color} />
  },
  {
    primaryText: "resources.customers.name",
    name: "customers",
    icon: <CustomersIcon color={BMTheme.icons.color} />
  },
  {
    primaryText: "resources.suppressions.name",
    name: "suppressions",
    icon: <CustomersIcon color={BMTheme.icons.color} />
  }
];

const checkItems = [
  {
    primaryText: "resources.gametips.name",
    name: "speltips",
    icon: <SpeltipsIcon color={BMTheme.icons.color} />
  },
  {
    primaryText: "resources.virtualSlips.name",
    name: "virtualslips",
    icon: <VirtualslipsIcon color={BMTheme.icons.color} />
  },
  {
    primaryText: "resources.promos.name",
    name: "promos",
    icon: <PromotionsIcon color={BMTheme.icons.color} />
  }
];

const messagesItems = [
  {
      primaryText: "resources.storeMessages.name",
      name: "store_messages",
      icon: <WelcomeMessageIcon color={BMTheme.icons.color} />
    },
    {
    primaryText: "resources.messageTemplates.name",
    name: "message_templates",
    icon: <WelcomeMessageIcon color={BMTheme.icons.color} />
  }
];

class Menu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isExpanded: false
    }
  }
  onToggleTapped = (isExpanded) => {
    this.setState({
      isExpanded: !isExpanded
    });
  }

  render() {
    const {
      translate,
      logout,
      configuration,
    } = this.props;

    const configurationCheck = item => {
      return (
        configuration &&
        configuration[item.name] &&
        configuration[item.name].enabled &&
        configuration[item.name].enabled === true && (
          <MenuItemLink
            style={menuStyle.item}
            key={item.name}
            to={`/${item.name}`}
            primaryText={translate(`${item.primaryText}`, {
              smart_count: 2
            })}
            leftIcon={item.icon}
            onClick={() => { }}
          />
        )
      );
    };

    return (
      <div style={menuStyle.main}>
        <WithPermission value="admin">
          {adminItems.map(item => (
            item.name === 'partners' ?
              <List key="users-list">
                <ListItem
                  key="users-listItem"
                  style={menuStyle.item}
                  primaryText={translate("resources.users.name")}
                  initiallyOpen={false}
                  primaryTogglesNestedList
                  leftIcon={item.icon}
                  rightIcon={<RightArrowIcon color={BMTheme.icons.color} onToggleTapped={this.onToggleTapped} isExpanded={this.state.isExpanded} />}
                  onClick={()=>this.onToggleTapped(this.state.isExpanded)}
                  nestedItems={[
                    <MenuItemLink
                      style={menuStyle.item}
                      key={item.name}
                      to={`/${item.name}`}
                      primaryText={translate(`${item.primaryText}`, {
                        smart_count: 2
                      })}
                      leftIcon={item.icon}
                      onClick={() => { }}
                    />,
                    <MenuItemLink
                      style={menuStyle.item}
                      key="admins"
                      to="/admins"
                      primaryText={translate("resources.admins.name")}
                      leftIcon={item.icon}
                      onClick={() => { }}
                    />
                  ]}
                />
              </List>
              : <MenuItemLink
                style={menuStyle.item}
                key={item.name}
                to={`/${item.name}`}
                primaryText={translate(`${item.primaryText}`, {
                  smart_count: 2
                })}
                leftIcon={item.icon}
                onClick={() => { }}
              />
          ))}

          {checkItems.map(item => configurationCheck(item))}

          {messagesItems.map(item => (
            <MenuItemLink
              style={menuStyle.item}
              key={item.name}
              to={`/${item.name}`}
              primaryText={translate(`${item.primaryText}`, {
                smart_count: 2
              })}
              leftIcon={item.icon}
              onClick={() => { }}
            />
          ))}


          <MenuItemLink
            style={menuStyle.item}
            key="regions"
            to="/regions"
            primaryText={translate("resources.regions.name")}
            leftIcon={<RegionsIcon color={BMTheme.icons.color} />}
            onClick={() => { }}
          />

          <MenuItemLink
            style={menuStyle.item}
            key="devices"
            to="/devices"
            primaryText={translate("resources.devices.name")}
            leftIcon={<DevicesIcon color={BMTheme.icons.color} />}
            onClick={() => { }}
          />

          <MenuItemLink
            style={menuStyle.item}
            key="reports"
            to="/reports"
            primaryText={translate("resources.reports.name")}
            leftIcon={<ReportsIcon color={BMTheme.icons.color} />}
            onClick={() => { }}
          />
        </WithPermission>

        <WithPermission value="partner">

          <MenuItemLink
            style={menuStyle.item}
            key="activation"
            to="/activation"
            primaryText={translate("resources.activation.name")}
            leftIcon={<GiftCardIcon color={BMTheme.icons.color} />}
            onClick={() => { }}
          />
        </WithPermission>
        {logout}
      </div>
    );
  }
};

const enhance = compose(
  connect(state => {
    return {
      theme: state.theme,
      locale: state.locale
    };
  }),
  translate
);

export default enhance(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu/index.js